import { SxProps, Theme } from '@mui/material';
import { t } from 'i18next';

import { spacing } from '~theme/AppTheme';

type AllFilesTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: AllFilesTableColumn[] = [
  {
    key: 'files',
    title: `${t(`approvals.files.all_files_table.headers.file`)}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'upload_date',
    title: `${t(`approvals.files.all_files_table.headers.upload_date`)}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  { key: 'category', title: 'Category', size: '1fr', sx: { p: 1, overflow: 'hidden' } },
  {
    key: 'uploaded_by',
    title: `${t(`approvals.files.all_files_table.headers.uploaded_by`)}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'description',
    title: `${t(`approvals.files.all_files_table.headers.description`)}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'actions',
    size: `calc(90px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
